import { useEffect, useState } from 'react';
import STATE from '../../../constanta/state';
import SelectInput from '../../../components/input/select.input';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../../components/input/text.input';
import axios from 'axios';
import Cookies from 'js-cookie';
import CONFIG from '../../../constanta/config';
import LogoApp from '../../../components/logoapp';

const CardStart = (props) => {
  const [loading, setLoading] = useState(false);
  const [listTerritory, setListTerritory] = useState([]);
  const [loadingTerritoy, setLoadingTerritoy] = useState(false);
  const [listUser, setListUser] = useState([]);
  const [loadingUser, setLoadingUser] = useState(false);
  const [name, setName] = useState('');
  const [msgError, setMsgError] = useState('');

  const validationSchema = Yup.object().shape({

    name: Yup.string().required('Team Name is required')
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  const listTeam = [
    { name: 'Team 1', value: 'Team 1' },
    { name: 'Team 2', value: 'Team 2' },
    { name: 'Team 3', value: 'Team 3' },
    { name: 'Team 4', value: 'Team 4' },
    { name: 'Team 5', value: 'Team 5' },
    { name: 'Team 6', value: 'Team 6' },
    { name: 'Team 7', value: 'Team 7' },
    { name: 'Team 8', value: 'Team 8' },
    { name: 'Team 9', value: 'Team 9' },
    { name: 'Team 10', value: 'Team 10' }
  ];

  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors }
  } = useForm(formOptions);

  const onSubmit = async (data) => {
    props.handleLogin(data);
  };

  return (
    <div className="w-full px-0 flex justify-center items-center">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="rounded-lg w-full md:h-max flex flex-col justify-between items-start px-5 md:w-2/3 bg-[#ffffffd9] border-[4px] py-2 md:py-4">
        <div className="flex flex-col justify-center items-center w-full">
          <LogoApp />
          <div>
            <div className="mb-2 text-xl text-center font-bold text-black">
            WELCOME TO THE CHALLENGER DIGITAL QUIZ!
            </div>
            <div className="font-semibold">ENTER YOUR TEAM’S NAME TO BEGIN</div>
          </div>

<br/>
          <TextInput
            label=""
            register={register}
            name="name"
            placeholder="Type your team name"
            isInvalid={errors.name}
            isRequired
          />
          {msgError !== '' && (
            <div className="flex justify-center items-center bg-red-400 mt-2 rounded-lg py-2 text-white w-full font-bold">
              <span>{msgError}</span>
            </div>
          )}
        </div>

        <div className="flex mt-4 justify-between w-full space-x-2">
          {/* <button
            onClick={() => props.onBack()}
            type="button"
            className=" flex-none w-24 font-bold cursor-pointer flex justify-center items-center text-base text-white h-[45px] px-2 border-b-4 border-red-700 bg-red-500 rounded-lg "
          >
            BACK
          </button> */}
          <button className="font-bold cursor-pointer w-full flex justify-center items-center text-base text-white h-[45px] px-2 border-b-4 border-blue-700 bg-blue-500 rounded-lg ">
            {loading ? 'Loading...' : 'BEGIN'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CardStart;
